import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebookF,
  faInstagram,
  faLinkedin,
  faTwitter,
  faWhatsapp
} from '@fortawesome/free-brands-svg-icons';

import {
  faShield as fadShield,
  faAward as fadWard,
  faComments as fadComments
} from '@fortawesome/pro-duotone-svg-icons';

import {
  faEnvelope,
  faArrowRight,
  faChevronDown,
  faChevronRight,
  faChevronLeft,
  faHeart,
  faGrid2,
  faArrowUp,
  faClock,
  faAward,
  faPlane,
  faLocationArrow,
  faCheck,
  faBadgeCheck,
  faSearch,
  faArrowDown,
  faFileUser,
  faBars,
  faShield,
  faWindTurbine,
  faConveyorBelt,
  faJoystick,
  faCode,
  faPlug,
  faGear,
  faPhone,
  faComments,
  faPlus,
  faMinus,
  faLock,
  faCircleInfo,
  faEuroSign,
  faSlidersUp,
  faPlay,
  faPaperPlane,
  faPaperclip,
  faCaretDown,
  faRotateRight,
  faFilter,
  faStar
} from '@fortawesome/pro-solid-svg-icons';

import {
  faXmark,
  faRocket as farRocket,
  faFileContract as farFileContract,
  faLockKeyhole as farLockKeyhole,
  faHandshake as farHandshake,
  faScrewdriverWrench as farScrewdriverWrench,
  faUserShield as farUserShield,
  faPlay as farPlay,
  faArrowUpRightFromSquare,
  faStar as farStar,
  faStarHalfStroke as farStarHalfStroke
} from '@fortawesome/pro-regular-svg-icons';

const icons = {
  facebook: faFacebookF,
  instagram: faInstagram,
  linkedin: faLinkedin,
  twitter: faTwitter,
  whatsapp: faWhatsapp,
  mail: faEnvelope,
  envelope: faEnvelope,
  'arrow-right': faArrowRight,
  grid: faGrid2,
  'chevron-down': faChevronDown,
  'chevron-right': faChevronRight,
  'chevron-left': faChevronLeft,
  heart: faHeart,
  'arrow-up': faArrowUp,
  clock: faClock,
  award: faAward,
  plane: faPlane,
  location: faLocationArrow,
  'x-mark': faXmark,
  checkmark: faCheck,
  'badge-checkmark': faBadgeCheck,
  search: faSearch,
  'arrow-down': faArrowDown,
  'file-user': faFileUser,
  bars: faBars,
  shield: faShield,
  'shield-duotone': fadShield,
  'award-duotone': fadWard,
  'rocket-regular': farRocket,
  'file-contract-regular': farFileContract,
  'lock-keyhole-regular': farLockKeyhole,
  'wind-turbine': faWindTurbine,
  'conveyor-belt': faConveyorBelt,
  joystick: faJoystick,
  code: faCode,
  plug: faPlug,
  gear: faGear,
  'handshake-regular': farHandshake,
  'screwdriver-wrench-regular': farScrewdriverWrench,
  'user-shield-regular': farUserShield,
  phone: faPhone,
  comments: faComments,
  play: faPlay,
  'external-link': faArrowUpRightFromSquare,
  plus: faPlus,
  minus: faMinus,
  'comments-duotone': fadComments,
  lock: faLock,
  'circle-info': faCircleInfo,
  euro: faEuroSign,
  'sliders-up': faSlidersUp,
  'play-regular': farPlay,
  'paper-plane': faPaperPlane,
  'paper-clip': faPaperclip,
  'caret-down': faCaretDown,
  'rotate-right': faRotateRight,
  filter: faFilter,
  star: faStar,
  'star-regular': farStar,
  'star-half-regular': farStarHalfStroke
};

export type IconProps =
  | 'facebook'
  | 'instagram'
  | 'linkedin'
  | 'twitter'
  | 'mail'
  | 'whatsapp'
  | 'arrow-right'
  | 'grid'
  | 'chevron-down'
  | 'chevron-right'
  | 'chevron-left'
  | 'heart'
  | 'arrow-up'
  | 'clock'
  | 'award'
  | 'plane'
  | 'location'
  | 'x-mark'
  | 'checkmark'
  | 'badge-checkmark'
  | 'search'
  | 'arrow-down'
  | 'file-user'
  | 'bars'
  | 'shield'
  | 'shield-duotone'
  | 'award-duotone'
  | 'rocket-regular'
  | 'file-contract-regular'
  | 'lock-keyhole-regular'
  | 'wind-turbine'
  | 'conveyor-belt'
  | 'joystick'
  | 'code'
  | 'plug'
  | 'gear'
  | 'handshake-regular'
  | 'screwdriver-wrench-regular'
  | 'user-shield-regular'
  | 'comments'
  | 'play'
  | 'external-link'
  | 'plus'
  | 'minus'
  | 'phone'
  | 'comments-duotone'
  | 'lock'
  | 'circle-info'
  | 'euro'
  | 'sliders-up'
  | 'play-regular'
  | 'envelope'
  | 'paper-plane'
  | 'paper-clip'
  | 'caret-down'
  | 'rotate-right'
  | 'filter'
  | 'star'
  | 'star-regular'
  | 'star-half-regular';

interface Props {
  icon: IconProps;
  color?: string;
  className?: string;
}

function Icon({
  icon,
  color = 'currentColor',
  className = ''
}: Props) {
  return (
    <FontAwesomeIcon
      color={color}
      icon={icons[icon]}
      className={className}
    />
  );
}

export default Icon;
